module.exports = __webpack_public_path__ + "img/img15.0e760153.jpg";